import { render, staticRenderFns } from "./RecoverPasswordToken.vue?vue&type=template&id=b3bde6d8"
import script from "./RecoverPasswordToken.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports